import { useMemo } from "react";
import { Chart } from "@highcharts/react";
import { useTranslation } from "react-i18next";
import { trellisPalette } from "../../../components/custom/analytics/palettes";
import Loading from "../../../components/core/blocks/Loading";
import { formatCurrency } from "../../../utils/formatNumber";

const WeeklySeasonalityChart = ({ data, isLoading, dailyBudget, marketPlace }) => {
  const { t } = useTranslation(["advertising"]);
  const options = useMemo(() => {
    return {
      chart: {
        type: "column",
        style: {
          "font-family": "Poppins",
          "font-weight": 700,
          "font-size": "15px",
        },
        height: 330,
      },
      title: {
        text: t(($) => $.advertising["Category Weekday Sales Trend"]),
      },

      yAxis: {
        startOnTick: false,
        title: {
          text: t(($) => $.advertising["Sales Trend"]),
        },
        labels: {
          enabled: false,
        },
        enableMouseTracking: false,
      },
      xAxis: {
        categories: [
          t(($) => $.advertising["Monday"]),
          t(($) => $.advertising["Tuesday"]),
          t(($) => $.advertising["Wednesday"]),
          t(($) => $.advertising["Thursday"]),
          t(($) => $.advertising["Friday"]),
          t(($) => $.advertising["Saturday"]),
          t(($) => $.advertising["Sunday"]),
        ],
      },
      plotOptions: {
        bar: {
          dataLabels: {
            enabled: true,
          },
        },
      },
      tooltip: {
        shared: true,
        formatter: function () {
          const points = this.points;
          let markup = "";

          for (let index = 0; index < points.length; index++) {
            const point = points[index];
            markup +=
              '<span style="color:' +
              point.series.color +
              '">\u25CF</span> ' +
              point.series.name +
              ": " +
              Math.round(point.y) +
              "%<br/>";
          }
          if (points[1]?.y !== undefined) {
            markup +=
              '<span style="color:' +
              points[1]?.series?.color +
              '">\u25CF</span> ' +
              t(($) => $.advertising["Daily Budget"]) +
              ": " +
              formatCurrency((points[1].y / 100) * dailyBudget, {
                marketPlace: marketPlace,
              }) +
              "<br/>";
          }
          return markup;
        },
      },
      series: [
        {
          name: t(($) => $.advertising["Weekday Parting"]),
          color: trellisPalette[1],
          data: data?.map((d) => d?.norm_weekly_season),
        },
        {
          name: t(($) => $.advertising["Weekday Budget Modifier"]),
          color: trellisPalette[5],
          data: data?.map((d) => d.multiplier),
          type: "area",
          fillOpacity: 0.1,
        },
      ],
    };

    // oxlint-disable-next-line react-hooks/exhaustive-deps
  }, [data, t]);

  if (isLoading) {
    return <Loading height={"300px"} fullPage={false} />;
  }

  return <Chart options={options} />;
};

export default WeeklySeasonalityChart;
